import { API_CALLS } from "@/services/apis/index.js";

export default {
    checkAspects(context, body) {
        return new Promise((resolve, reject) => {
            API_CALLS.checkAspects(body)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    saveAspectOverrides(context, body) {
        return new Promise((resolve, reject) => {
            API_CALLS.saveAspectOverrides(body)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};
